import { Component, Injector } from '@angular/core';
import { AbstractBuilderComponent, BuilderDataAbstract } from '../../shared/components/abstract-builder/abstract-builder.component';
import { FormBuilder, Validators } from '@angular/forms';
import { validateAllFormFields } from '../../../../shared/validators';
import * as moment from 'moment';
import { HistoryData } from '../../../../shared/components/history-view/history-view.component';
import { LoadingStateService } from '../../../../shared/services/common/loading-state.service';
import { BuilderData } from '../../../../shared/models/clincal-note.model';

export interface MskExamFormData extends BuilderDataAbstract {
  note: string;
}

@Component({
  selector: 'app-msk-exam',
  templateUrl: './msk-exam.component.html',
  styleUrls: ['./msk-exam.component.scss']
})
export class MskExamComponent extends AbstractBuilderComponent {

  constructor(
    private fb: FormBuilder
  ) {
    super();
    this.formData = this.fb.group({
      note: [null, [Validators.required, Validators.maxLength(500)]]
    });
  }

  public override async validate() {
    validateAllFormFields(this.formData);

    return this.formData.valid;
  }

  public clearInput() {
    this.formData.get('note')?.reset();
  }

  serialize(data: MskExamFormData): HistoryData[] {
    if (!data) {
      return [];
    }

    return [{
      type: 'builder',
      builderTitle: 'MSK EXAM:',
      author: data.author ? data.author.name : '',
      dateTime: moment(data._modified!).format(),
      content: data.note
    }];
  }

  asString(data: MskExamFormData): string {
    if (!data) return '';

    return [
      `[${moment(data._modified!).format('YYYY-MM-DD HH:mm')}${data.author ? `; ${data.author.name}` : ''}]: MSK EXAM`,
      data.note
    ].join('\n');
  }

  protected getBuilderData(): BuilderData {
    const data = this.formData.getRawValue() as MskExamFormData;
    data['_modified'] = moment().valueOf();

    let builderData = this.data;
    if (!builderData) {
      builderData = data;
    } else {
      builderData = data;
    }
    return builderData;
  }

}
